/**
 * @type {Array}
 */
const themeColors = ["#28C76F", "#7367F0", "#EA5455", "#FF9F43", "#1E1E1E"];

/**
 * @type {object}
 */
const options = {year: "numeric", month: "short"};

/**
 * Calculates a date given the parameter, with today date as base
 * @param {number} minus - Number of month to retrieve from the current month
 * @param {boolean} needLocalDate - False by default, if true it will return a date with local format
 * @return {string} date to ISO string
 */
const getDate = (minus, needLocalDate) => {
	let y = minus || 0;
	let today = new Date();
	let day = today.getDate();
	let month = today.getMonth();
	let year = today.getFullYear();
	let date = new Date(year, month, day);
	date.setMonth(date.getMonth() - y);
	if(needLocalDate) {
		return date.toLocaleDateString("en-EN", options);
	}
	else{
		return date.toISOString().slice(0, 10);
	}
};

/**
 * @type {Array<number>}
 */
const monthCategories = [
	getDate(11),
	getDate(10),
	getDate(9),
	getDate(8),
	getDate(7),
	getDate(6),
	getDate(5),
	getDate(4),
	getDate(3),
	getDate(2),
	getDate(1),
	getDate()
];

/**
 * @type {Array<number>}
 */
const localMonthCategories = [
	getDate(11, true),
	getDate(10, true),
	getDate(9, true),
	getDate(8, true),
	getDate(7, true),
	getDate(6, true),
	getDate(5, true),
	getDate(4, true),
	getDate(3, true),
	getDate(2, true),
	getDate(1, true),
	getDate(0, true)
];
export default {
	methods: {
		/**
		 * Create an object that contains every information to load a Radial chart
		 * @param {string} chartName - Name of the chart
		 * @param {number} total1 - Organic total
		 * @param {number} total2 - Global total
		 * @param {string} chartDescription - Description of the chart
		 * @return {object} Return options for chart as object
		 */
		setRadialChartOptions: (chartName, total1, total2, chartDescription) => {
			let chartOptions = {
				name: chartName,
				data: [total1, total2],
				series: [parseInt(((total1 * 100) / total2).toFixed(2))],
				chartOptions: {
					colors: ["#20E647"],
					chart: {
						fontFamily: "'Montserrat', Helvetica, Arial, sans-serif"
					},
					legend: {
						position: "top"
					},
					plotOptions: {
						radialBar: {
							startAngle: 0,
							endAngle: 360,
							hollow: {
								margin: 0,
								size: "70%",
								background: "#293450",
								position: "front",
								dropShadow: {
									enabled: false,
									top: 0,
									left: 0,
									blur: 3,
									opacity: 0.24
								}
							},
							track: {
								dropShadow: {
									enabled: true,
									top: 2,
									left: 0,
									blur: 4,
									opacity: 0.35
								}
							},
							dataLabels: {
								showOn: "always",
								name: {
									offsetY: -10,
									show: true,
									color: "#fff",
									fontSize: "13px"
								},
								value: {
									color: "#fff",
									fontSize: "30px",
									show: true
								}
							}
						}
					},
					stroke: {
						lineCap: "round"
					},
					fill: {
						type: "gradient",
						gradient: {
							shade: "dark",
							type: "vertical",
							gradientToColors: ["#87D4F9"],
							stops: [0, 100]
						}
					},
					labels: [chartDescription]
				}
			};
			return chartOptions;
		},

		/**
		 * Create an object that contains every information to load a Radial Bar chart
		 * @param {number} total1 - Organic total
		 * @param {number} total2 - Global total
		 * @param {string} chartDescription - Description of the chart
		 * @param {string} label1 - Description of the first total
		 * @param {string} label2 - Description of the second total
		 * @param {boolean} showTotal - Show or not the total
		 * @return {object} Return options for chart as object
		 */
		setRadialBarOptions: (
			total1,
			total2,
			chartDescription,
			label1,
			label2,
			showTotal
		) => {
			let chartOptions = {
				series: [total1, total2],
				chartOptions: {
					chart: {
						fontFamily: "'Montserrat', Helvetica, Arial, sans-serif"
					},
					legend: {
						position: "top"
					},
					plotOptions: {
						radialBar: {
							dataLabels: {
								name: {
									fontSize: "22px"
								},
								value: {
									fontSize: "16px"
								},
								total: {
									show: showTotal,
									label: chartDescription,
									formatter: function(w) {
										// By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
										return 249;
									}
								}
							}
						}
					},
					labels: [label1, label2]
				}
			};
			return chartOptions;
		},

		/**
		 * Create an object that contains every information to load a Column chart
		 * @param {string} chartName - Name of the chart
		 * @param {Array<number>} total1 - Organic total
		 * @param {Array<number>} total2 - Global total
		 * @param {string} serieName1 - Name of the serie
		 * @param {string} serieName2 - Name of the serie
		 * @param {Array<string>} categories - Description of the second total
		 * @param {string} valueType - Description of the value ("%" for instance)
		 * @return {object} Return options for chart as object
		 */
		setColumnChartOptions: (
			chartName,
			total1,
			total2,
			serieName1,
			serieName2,
			categories,
			valueType
		) => {
			let valTypo = " ";
			if(valueType) {
				valTypo = valueType;
			}
			let columnCharts = {
				name: chartName,
				series: [
					{
						name: serieName1,
						data: [total1]
					},
					{
						name: serieName2,
						data: [total2]
					}
				],
				chartOptions: {
					chart: {
						fontFamily: "'Montserrat', Helvetica, Arial, sans-serif",
						toolbar: {show: false}
					},
					plotOptions: {
						bar: {
							borderRadius: 8,
							horizontal: false,
							columnsWidth: "55%"
						}
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						show: true,
						width: 2,
						color: ["transparent"]
					},
					xaxis: {
						categories: [categories]
					},
					fill: {
						opacity: 1
					},
					legend: {
						position: "top"
					},
					tooltip: {
						y: {
							formatter: function(val) {
								return val + valTypo;
							}
						}
					}
				}
			};
			return columnCharts;
		},

		/**
		 * Create an object that contains every information to load a Stacked Column Bar chart
		 * @param {Array<number>} total1 - Organic total
		 * @param {Array<number>} total2 - Global total
		 * @param {Array<number>} total3 - Global total
		 * @param {string} serieName1 - Name of the serie
		 * @param {string} serieName2 - Name of the serie
		 * @param {string} serieName3 - Name of the serie
		 * @param {Array<string>} [categories] - Description of the second total
		 * @return {object} Return options for chart as object
		 */
		setStackedColumnBarOptions: (
			total1,
			total2,
			total3,
			serieName1,
			serieName2,
			serieName3,
			categories
		) => {
			let columnCharts = {
				series: [
					{
						name: serieName1,
						data: total1
					},
					{
						name: serieName2,
						data: total2
					},
					{
						name: serieName3,
						data: total3
					}
				],
				chartOptions: {
					chart: {
						width: "100%",
						fontFamily: "'Montserrat', Helvetica, Arial, sans-serif",
						background: "#fff",
						stacked: true,
						toolbar: {show: false}
					},
					legend: {
						inverseOrder: true
					},
					plotOptions: {
						bar: {
							horizontal: false
						}
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						show: true,
						width: 2,
						color: ["transparent"]
					},
					xaxis: {
						type: "categories",
						categories: localMonthCategories
					},
					yaxis: {
						title: {
							text: "Mots clés"
						}
					},
					fill: {
						opacity: 1
					},
					legend: {
						position: "top"
					},
					tooltip: {
						shared: true,
						inverseOrder: true,
						y: {
							formatter: function(val) {
								return val + " mots clés";
							}
						}
					}
				}
			};
			return columnCharts;
		},

		/**
		 * Create an object that contains every information to load a Line Chart (from Jan to Dec)
		 * @param {Array<number>} data - Organic total
		 * @param {string} serieName1 - Name of the serie
		 * @param {string} chartDescription - Description of the chart
		 * @return {object} Return options for chart as object
		 */
		setLineChartYearlyOptions: (data, serieName1, chartDescription) => {
			let lineChart = {
				series: [
					{
						name: serieName1,
						data: data
					}
				],
				chartOptions: {
					chart: {
						fontFamily: "'Montserrat', Helvetica, Arial, sans-serif",
						height: 350,
						width: 800,
						zoom: {
							enabled: false
						},
						toolbar: {show: false}
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						show: true,
						curve: "straight",
						width: 2,
						color: ["transparent"]
					},
					title: {
						text: chartDescription,
						align: "left"
					},
					grid: {
						row: {
							colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
							opacity: 0.5
						}
					},
					xaxis: {
						categories: [
							"Jan",
							"Fev",
							"Mar",
							"Avr",
							"Mai",
							"Juin",
							"Jui",
							"Août",
							"Sep",
							"Oct",
							"Nov",
							"Dec"
						]
					},
					yaxis: {
						title: {
							text: "Position"
						}
					},
					fill: {
						opacity: 1
					},
					tooltip: {
						y: {
							formatter: function(val) {
								return val;
							}
						}
					},
					legend: {
						position: "top"
					}
				}
			};
			return lineChart;
		},

		/**
		 * Create a chart object that contains every information to load a Line Area Chart (from Jan to Dec)
		 * @param {Array<object>} data - Array containing data / name for each series
		 * @param {Array<string>} categories - Array of "categories" (eg: array of months)
		 * @param {string} chartId - ID for the chart
		 * @return {object} Return options for chart as object
		 */
		setLineAreaChartOptionsV2: (data, categories, chartId) => {
			let colorIndex = 0;
			let lineAreaChart = {
				series: [],
				chartOptions: {
					chart: {
						id: chartId || null,
						fontFamily: "'Montserrat', Helvetica, Arial, sans-serif",
						toolbar: {show: false}
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						curve: "smooth",
						width: 2
					},
					fill: {
						type: "solid",
						opacity: 1
					},
					colors: themeColors,
					xaxis: {
						categories: categories || monthCategories
					},
					/*
					 * tooltip: {
					 *   x: {
					 *     format: "MM/yy"
					 *   }
					 * },
					 */
					grid: {
						show: true,
						xaxis: {
							lines: {
								show: true
							}
						},
						yaxis: {
							lines: {
								show: true
							}
						}
					},
					legend: {
						fontSize: 15,
						position: "top"
					},
					yaxis: []
				}
			};
			Object.keys(data).forEach(elem => {
				if(elem != "keys") {
					lineAreaChart.series.push({
						data: data[elem].data,
						name: data[elem].name,
						type: "line"
					});
					let allValuesZero = true;
					for(let row of data[elem].data){
						if(row & row > 0){
							allValuesZero = false;
							break;
						}
					}
					lineAreaChart.chartOptions.yaxis.push({
						seriesName: data[elem].name,
						opposite: colorIndex % 2 == 1 ? true : false,
						reversed: elem == "pos" ? true : false,
						max: elem == "pos" || allValuesZero ? 100 : false,
						axisTicks: {
							show: true
						},
						axisBorder: {
							show: true,
							color: themeColors[colorIndex]
						},
						labels: {
							style: {
								colors: themeColors[colorIndex]
							}
						},
						title: {
							text: data[elem].name,
							style: {
								color: themeColors[colorIndex]
							}
						}
					});
					colorIndex += 1;
				}
			});
			if(Object.keys(data).length == 3) {
				lineAreaChart.chartOptions.colors = [
					"#28C76F",
					"#7367F0",
					"#FF9F43",
					"#EA5455",
					"#1E1E1E"
				];
				/*
				 * lineAreaChart.chartOptions.yaxis[2].axisBorder.color = "#ffc085";
				 * lineAreaChart.chartOptions.yaxis[2].labels.style.colors = "#ffc085";
				 * lineAreaChart.chartOptions.yaxis[2].title.style.color = "#ffc085";
				 * lineAreaChart.chartOptions.yaxis[2].reversed = true;
				 */
			}
			return lineAreaChart;
		},

		/**
		 * Create a chart object that contains every information to load a Radial Chart
		 * @param {number} data - Value of the metric  (the only numeric value displayed on the chart)
		 * @param {string} chartName - Name of the chart
		 * @return {object} eturn options for chart as object
		 */
		setRadialBasicOptions: (data, chartName) => {
			let color = "";
			let bgColor = "";
			if(data >= 90) {
				color = "#20E647";
				bgColor = "#e5f9ef";
			}
			if(data <= 49) {
				color = "#ff4e42";
				bgColor = "#ffeceb";
			}
			if(data >= 50 && data <= 89) {
				color = "#ffa400";
				bgColor = "#fff5e4";
			}

			let chartOptions = {
				name: chartName,
				data: [data],
				series: [parseInt(data)],
				chartOptions: {
					colors: [color],
					chart: {
						background: "#fff",
						foreColor: color,
						fontFamily: "'Montserrat', Helvetica, Arial, sans-serif"
					},
					legend: {
						position: "top"
					},
					plotOptions: {
						radialBar: {
							startAngle: 0,
							endAngle: 360,
							hollow: {
								margin: 0,
								size: "70%",
								background: bgColor,
								position: "front"
							},
							dataLabels: {
								showOn: "always",
								name: {
									offsetY: -10,
									show: true,
									color: color,
									fontSize: "17px"
								},
								value: {
									color: color,
									fontSize: "30px",
									show: true,
									formatter: function(val) {
										return val;
									}
								}
							}
						}
					},
					stroke: {
						lineCap: "round"
					},
					fill: {
						type: "solid"
					},
					labels: [chartName]
				}
			};
			return chartOptions;
		}
	}
};
